import React, { useRef, useEffect } from "react";
// @ts-expect-error Missing types
import SignatureCanvas from "react-signature-canvas";
import { useTranslation } from "react-i18next";


interface SignaturePadProps {
  onChange: (file: File) => void;
  defaultValue?: string; // prefill image URL
}

export default function SignaturePad({
  onChange,
  defaultValue,
}: SignaturePadProps) {
  const { t } = useTranslation();
  const sigCanvas = useRef<SignatureCanvas>(null);

  useEffect(() => {
    if (defaultValue && sigCanvas.current) {
      fetch(defaultValue, { mode: "cors" })
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            sigCanvas.current?.fromDataURL(reader.result as string);
          };
          reader.readAsDataURL(blob);
        })
        .catch(console.error);
    }
  }, [defaultValue]);

  const clear = () => {
    sigCanvas.current?.clear();
    onChange(undefined as unknown as File);
  };

  const save = async () => {
    if (!sigCanvas.current) return;
    const canvas = sigCanvas?.current?.getTrimmedCanvas();
    const signatureImage = canvas?.toDataURL("image/png");
    const blob = await fetch(signatureImage).then((res) => res.blob());

    const file = new File([blob], "signature.png", { type: "image/png" });
    onChange(file);
  };

  return (
    <div>
      <SignatureCanvas
        ref={sigCanvas}
        penColor="black"
        canvasProps={{
          width: 350,
          height: 200,
          className: "border border-gray-300 rounded",
        }}
      />
      <div className="mt-2">
        <button type="button" className={"btn btn-light me-2"} onClick={clear}>
          {t("general.signatureClear")}
        </button>
        <button type="button" className={"btn btn-primary"} onClick={save}>
          {t("general.signatureSave")}
        </button>
      </div>
    </div>
  );
}
